import { Config, Effect, Option } from 'effect';

import { ConfigKey } from './keys';

// Optional CDN public URL. Unset in local dev — `resolveImageUrl` then
// returns the backend `resolve` URL directly and there is nothing to fall
// back to.
export const GcsPublicUrlConfig = Config.option(Config.URL(ConfigKey.GcsPublicUrl));

// Resolved CDN prefix as a plain string with any trailing slash stripped, so
// the rest of the codebase can concatenate `/cache/...` without
// double-slashing. Mirrors the backend address module.
export const getGcsPublicUrl = Effect.gen(function* () {
  const urlOption = yield* GcsPublicUrlConfig;
  return Option.map(urlOption, (url) => url.toString().replace(/\/$/, ''));
});
